// src/services/techniquesPhotoServices.js
import axios from "axios";

// Compat Vite & CRA
const _base =
  (typeof import.meta !== "undefined" &&
    import.meta.env &&
    import.meta.env.VITE_API_URL) ||
  process.env.REACT_APP_API_URL ||
  "";

export const baseUrl = _base.replace(/\/$/, "");

// Routes serveur sous /api/techniques
const techniquesBase = `${baseUrl}/api/techniques`;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Upload/Remplace l'image (image1_url) d’une technique.
 * - POST /api/techniques/:id/photo?format=webp|jpg|png&maxWidth=...
 * - multipart/form-data, champ "file"
 * - Réponse: { ok: true, image1_url: "/uploads/..." }
 */
export const uploadTechniquePhoto = async (techniqueId, file, options = {}) => {
  if (!techniqueId) throw new Error("techniqueId requis");
  if (!file) throw new Error("file requis");

  const { format = "webp", maxWidth, onUploadProgress } = options;

  const form = new FormData();
  form.append("file", file);

  const qs = new URLSearchParams();
  if (format) qs.set("format", String(format));
  if (typeof maxWidth === "number") qs.set("maxWidth", String(maxWidth));

  try {
    const { data } = await axios.post(
      `${techniquesBase}/${encodeURIComponent(techniqueId)}/photo?${qs.toString()}`,
      form,
      {
        headers: {
          ...authHeaders(),
          // Content-Type multipart géré automatiquement par axios
        },
        onUploadProgress,
      }
    );
    return data; // { ok:true, image1_url }
  } catch (error) {
    console.error("[uploadTechniquePhoto] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

/**
 * Définir directement une URL existante comme image1_url (Cloudinary ou locale).
 * - PUT /api/techniques/:id/photo-url
 * - body: { image1_url: "https://..." ou "/uploads/..." }
 * - Réponse: { ok: true, image1_url }
 */
export const setTechniquePhotoUrl = async (techniqueId, image1_url) => {
  if (!techniqueId) throw new Error("techniqueId requis");
  if (!image1_url) throw new Error("image1_url requis");
  try {
    const { data } = await axios.put(
      `${techniquesBase}/${encodeURIComponent(techniqueId)}/photo-url`,
      { image1_url },
      { headers: { "Content-Type": "application/json", ...authHeaders() } }
    );
    return data; // { ok:true, image1_url }
  } catch (error) {
    console.error("[setTechniquePhotoUrl] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

/**
 * Supprimer l'image (et le fichier local si /uploads/...).
 * - DELETE /api/techniques/:id/photo
 * - Réponse: { ok: true }
 */
export const deleteTechniquePhoto = async (techniqueId) => {
  if (!techniqueId) throw new Error("techniqueId requis");
  try {
    const { data } = await axios.delete(
      `${techniquesBase}/${encodeURIComponent(techniqueId)}/photo`,
      { headers: { ...authHeaders() } }
    );
    return data; // { ok:true }
  } catch (error) {
    console.error("[deleteTechniquePhoto] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

/**
 * Helper pour <img src="...">
 * - /uploads/... => préfixe par baseUrl (API)
 * - sinon (https://...) => renvoie tel quel
 */
export const toAbsoluteTechniquePhotoUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("/uploads/")) return `${baseUrl}${url}`;
  return url;
};
